// 路由
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '史前遗址'
    }
  }
]
const router = new VueRouter({
  mode: 'history',
  // base: '/chinese-modern-history-map/', // vue.config.js
  base: '/', // vue.config.js
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
